import { DestinationType, DestinationTypeBm, type Distribution, type LensDestination } from "../../gql-generated/types";

export const addAdAccountsFromLensCentralDistributions = (
    destinations: readonly LensDestination[] = [],
    distributionsList: readonly Distribution[] = [],
    lensId: string,
): readonly LensDestination[] => {
    const destinationsNoAdAccounts = destinations.filter(
        (dest) => dest.destinationType !== DestinationTypeBm.DestinationTypeAdAccount,
    );

    const adAccountsDestinations = destinations.filter(
        (dest) => dest.destinationType === DestinationTypeBm.DestinationTypeAdAccount,
    );

    // if no add accounts is returned, fallback to the distributions list from LensCentral
    if (adAccountsDestinations.length === 0) {
        const adAccountsDestinationsLensCentral: LensDestination[] = distributionsList
            .filter((distribution) => distribution.destinationType === DestinationType.DestinationTypeAdAccount)
            .map(({ status, destinationId }) => ({
                status,
                destinationId,
                id: destinationId,
                lensId,
                destinationType: DestinationTypeBm.DestinationTypeAdAccount,
            }));

        return [...destinationsNoAdAccounts, ...adAccountsDestinationsLensCentral];
    }

    return destinations;
};
